import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './localization'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import { EventBus } from './utilites/eventBus'
import PortalVue from 'portal-vue'

Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(Vuex);
Vue.use(PortalVue);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas);
library.add(far);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// URL берется из Env переменной
// В случае с local dev - dev.env
// В случае с prod - prod.env подставляется при сборке
const API_URL = process.env.ROOT_API;

Vue.http.options.root = API_URL;

Vue.http.interceptors.unshift((request, next) => {
  const url = request.url;
  request.url = API_URL + url;
  const token = localStorage.getItem("token");
  if (token) {
    request.headers.set('Authorization', 'Bearer '+ token);
  } else {
    router.push('/login').catch(() => {});
    return;
  }

  next((response) => {
    if (response.status === 404) {
      if (!request.ignore404) {
      EventBus.$emit('http-error-404');
      }
    }

    if (url !== "login") {
      if (response.status === 401) {
        // TODO: Реализовать обнговление токена
        //updateRefreshToken();

        store.dispatch("logout").then(res => {
          router.push('/login').catch(() => {});
        });
        return;
      }

      if (response.status === 403) {
        EventBus.$emit('http-error-403');
      }
    }
  })
});

function updateRefreshToken() {
  Vue.http.get("refresh_token").then(result => {
    console.log(result);
    console.log(result.status);
  }, error => {
    console.log(error);
    console.log(error.status);

    store.dispatch("logout").then(res => {
      router.push('/login').catch(err => {});
    })
  })
}

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js